import { gql } from "@apollo/client";

export const CURRENT_USER_FRAGMENT = gql`
  fragment CurrentUserFragment on User {
    id
    firstName
    lastName
    fullName
    email

    role

    clientOrganization {
      id
      name
      logoUrl
      agencySlugId
    }

    recruiterOrganizationReport {
      uncuratedJobsCount
    }

    agency {
      name
      logoUrl
      slugId
      jobWebsite
      type
    }

    isOwner

    recruiterAgencySlugId
  }
`;

export const CURRENT_USER_QUERY = gql`
  ${CURRENT_USER_FRAGMENT}
  {
    currentUser {
      ...CurrentUserFragment
    }
  }
`;

export const UPDATE_CURRENT_USER_MUTATION = gql`
  mutation UpdateUserProfile($firstName: String!, $lastName: String!) {
    updateUserProfile(input: { firstName: $firstName, lastName: $lastName }) {
      id
      firstName
      lastName
    }
  }
`;

export const UPDATE_CURRENT_USER_AGENCY_MUTATION = gql`
  mutation UpdateUserAgency($agencySlugId: String!) {
    UpdateUserAgency(input: { slugId: $agencySlugId }) {
      id
      recruiterAgencySlugId
    }
  }
`;

// Recruiter-level email settings: the daily digest and its delivery time,
// plus on/off for the shortlist alert, role overview and review reminder
// emails. Recruiters only. Mirrored in moblyze-clients/src/graphql/.
export const RECRUITER_NOTIFICATION_SETTINGS_FRAGMENT = gql`
  fragment RecruiterNotificationSettingsFragment on RecruiterNotificationSettings {
    digestEnabled
    dailySendHour
    timezone
    shortlistAlertEnabled
    roleOverviewEnabled
    reviewReminderEnabled
    active
  }
`;

export const MY_RECRUITER_NOTIFICATION_SETTINGS_QUERY = gql`
  ${RECRUITER_NOTIFICATION_SETTINGS_FRAGMENT}
  query MyRecruiterNotificationSettings {
    myRecruiterNotificationSettings {
      ...RecruiterNotificationSettingsFragment
    }
  }
`;

export const SET_MY_RECRUITER_NOTIFICATION_SETTINGS_MUTATION = gql`
  ${RECRUITER_NOTIFICATION_SETTINGS_FRAGMENT}
  mutation SetMyRecruiterNotificationSettings(
    $input: RecruiterNotificationSettingsInput!
  ) {
    setMyRecruiterNotificationSettings(input: $input) {
      ...RecruiterNotificationSettingsFragment
    }
  }
`;
